var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgFilterSelected = function SvgFilterSelected(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#BEE7FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 20C10.2255 20 9.77778 19.5523 9.77778 19C9.77778 18.4477 10.2255 18 10.7778 18H13.2222C13.7745 18 14.2222 18.4477 14.2222 19C14.2222 19.5523 13.7745 20 13.2222 20H10.7778ZM6.33333 13C5.78105 13 5.33333 12.5523 5.33333 12C5.33333 11.4477 5.78105 11 6.33333 11H17.6667C18.219 11 18.6667 11.4477 18.6667 12C18.6667 12.5523 18.219 13 17.6667 13H6.33333ZM3 6C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H3Z",
    fill: "#0072B5"
  })));
};
var Memo = /*#__PURE__*/memo(SvgFilterSelected);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/FilterSelected.389a7aec0bb51cbb5a8cd75552bdb3f8.svg";